// extracted by mini-css-extract-plugin
export default {"wrap":"Table_wrap__yCR7Q","table":"Table_table__7VuZZ","th":"Table_th__mMtlg","tr":"Table_tr__qiawr","td":"Table_td__vcUuW","empty":"Table_empty__W+xOY"};